import { palette } from '@innovyze/stylovyze';
import { makeStyles } from '@mui/styles';

export const useStyle = makeStyles(() => ({
	header: {
		fontSize: '1.125rem',
		padding: '8px 24px 8px 24px',
		display: 'flex',
		height: '55px',
	},
	vl: {
		borderLeft: '5px solid ' + palette.primary.dark,
		height: '45px',
		//position: 'absolute',
		margin: '-3px 0 0 -19px',
		paddingLeft: '10px',
	},
	helpIcon: {
		width: '15px',
		color: 'rgb(218, 218, 218)',
		height: '15px',
		margin: '0px 0 0 5px',
		top: '4px',
		position: 'relative',
	},
	columnHelpIcon: {
		width: '15px',
		color: 'rgb(218, 218, 218)',
		height: '15px',
		margin: '-4px 0 0 3px',
	},
	columnHeaderBreaker: {
		width: 'calc( 100% + 48px)',
		marginLeft: '-24px',
		padding: '0 24px',
		backgroundColor: '#F7F7F7',
		height: '46px',
		'& div:nth-child(-n+2)': {
			fontsize: '14px',
			fontStyle: 'normal',
			fontWeight: 600,
			lineHeight: '20px',
			letterSpacing: '0px',
		},
		'& div:last-child': {
			fontSize: '12px',
			fontStyle: 'normal',
			fontWeight: 400,
			lineHeight: '16px',
			letterSpacing: '0px',
		},
	},
	root: {
		width: '100%',
		'& hr': {
			display: 'block',
			unicodeBidi: 'isolate',
			marginBlockStart: '0.5em',
			marginBlockEnd: '0.5em',
			marginInlineStart: 'auto',
			marginInlineEnd: 'auto',
			overflow: 'hidden',
			borderWidth: '1px',
		},
	},
	paper: {
		boxShadow:
			'0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',

		color: 'rgba(0, 0, 0, 0.87)',
		transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
		backgroundColor: '#fff',
	},
	divider: {
		border: 'none',
		height: '1px',
		margin: 0,
		flexShrink: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.12)',
	},
	cardBody: {
		padding: '12px 1.5rem',
	},
}));
